export const CONSENT_TEXT = 'I agree to save my anonymous device key, choices, and curve to the public aggregate commons.';
export const CONSENT_VERSION = '2026-06-05.v1';

export function ConsentGate({ onConsent }: { onConsent: () => void }) {
  return (
    <section className="panel consent-panel" aria-labelledby="consent-title">
      <p className="eyebrow">one-line consent</p>
      <h2 id="consent-title">Play first. Share only when you mean it.</h2>
      <p className="hero-copy">
        Patience Fingerprint is a tiny game about hyperbolic discounting: the way future rewards shrink in the mind, often steeply near “now” and more gently later.
      </p>
      <div className="consent-line">
        <span>{CONSENT_TEXT}</span>
      </div>
      <p className="microcopy">
        You can complete the game and see your result before saving. Submitting requires Turnstile so the dataset stays human-shaped.
      </p>
      <button className="primary-action" onClick={onConsent}>I understand — start the game</button>
    </section>
  );
}
